import generateTypes from '../utils/generateTypes';

export const IS_PARTICIPANT_VIEW = 'IS_PARTICIPANT_VIEW';
export const DATA_TAGS_VALUES = 'DATA_TAGS_VALUES';
export const DATA_TAGS_OPTIONS = 'DATA_TAGS_OPTIONS';
export const MAIN_DATA_TAGS_OPTIONS = 'MAIN_DATA_TAGS_OPTIONS';
export const ATTENDEE_FEEDBACK_MODAL = 'ATTENDEE_FEEDBACK_MODAL';
export const UPDATE_IMPERSONATED_USER = 'UPDATE_IMPERSONATED_USER';
